function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#050e30",
  d: "M21.734 12.5v9.563a2.44 2.44 0 0 1-2.437 2.437H2.702a2.44 2.44 0 0 1-2.437-2.437V.98a.467.467 0 0 1 .8-.344l1.327 1.328L3.721.637a.469.469 0 0 1 .663 0l1.328 1.328L7.04.637a.469.469 0 0 1 .663 0L9.03 1.965 10.359.637a.469.469 0 0 1 .662 0l1.328 1.328L13.677.637a.469.469 0 0 1 .663 0l1.328 1.328L16.996.637a.469.469 0 0 1 .8.332V12.03h3.47c.258 0 .468.21.468.469zM2.704 23.562h14.674a2.425 2.425 0 0 1-.519-1.5v-9.55V2.1l-.86.86a.469.469 0 0 1-.662 0l-1.328-1.328L12.68 2.96a.469.469 0 0 1-.663 0L10.69 1.632 9.362 2.96a.469.469 0 0 1-.663 0L7.371 1.632 6.044 2.96a.469.469 0 0 1-.663 0L4.053 1.632 2.725 2.96a.469.469 0 0 1-.663 0L1.203 2.1v19.962c0 .827.673 1.5 1.5 1.5zM20.796 12.97h-3v9.094c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#050e30",
  d: "M13.74 7.946h-.913a.469.469 0 0 0 0 .938h.913a.469.469 0 0 0 0-.938z"
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#050e30",
  d: "M5.235 7.946h-.913a.469.469 0 0 0 0 .938h.913a.469.469 0 0 0 0-.938z"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#050e30",
  d: "M13.977 13.157H6.551a.469.469 0 0 0 0 .937h7.426a.469.469 0 0 0 0-.937z"
}))));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#050e30",
  d: "M4.416 13.294a.472.472 0 0 0-.663 0 .472.472 0 0 0 0 .663.472.472 0 0 0 .663 0 .472.472 0 0 0 0-.663z"
}))));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#050e30",
  d: "M13.977 16.25H6.551a.469.469 0 0 0 0 .938h7.426a.469.469 0 0 0 0-.938z"
}))));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#050e30",
  d: "M4.416 16.388a.472.472 0 0 0-.663 0 .472.472 0 0 0 0 .662.473.473 0 0 0 .331.138.473.473 0 0 0 .47-.47.472.472 0 0 0-.138-.33z"
}))));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#050e30",
  d: "M13.977 19.344H6.551a.469.469 0 1 0 0 .937h7.426a.469.469 0 0 0 0-.937z"
}))));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#050e30",
  d: "M4.416 19.481a.472.472 0 0 0-.663 0 .472.472 0 0 0 0 .663.472.472 0 0 0 .663 0 .472.472 0 0 0 0-.663z"
}))));

var SvgIconViewInvoice = function SvgIconViewInvoice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "text-before-edge",
    style: {
      lineHeight: 21
    },
    fill: "#050e30",
    fontFamily: "'Poppins','Poppins-Medium'",
    fontSize: 6,
    transform: "translate(7 6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontKerning: "normal"
    }
  }, "\xA3"))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconViewInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-view-invoice.123820ab.svg";
export { ForwardRef as ReactComponent };